<div mat-dialog-title class="confirmation-dialog-title" *ngIf="data.title"
  [ngClass]="{'confirmation-dialog-title-red' : data.redTitle}">{{data.title}}</div>
<hr class="line" *ngIf="data.title">
<div mat-dialog-content class="confirmation-dialog-body" class="content-dialog">
  <div>
    <img class="info-icon3" *ngIf="data.imgSource" src="{{data.imgSource}}">{{data.msg}}
  </div>
  <div *ngIf="data.additionalText">{{data.additionalText}}</div>
</div>
<hr class="line">
<div mat-dialog-actions style="justify-content: end;">
  <button mat-raised-button *ngIf="!hideCancelButton" (click)="onNoClick()" class="confirmation-cancel">Cancel</button>
  <button mat-raised-button color="primary" style="background: #F64747;border: solid 1px #F64747;" [ngClass]="{'ok-btn-bg': hideCancelButton}"
    [mat-dialog-close]="true" cdkFocusInitial>{{buttonName}}</button>
</div>
